import { render, staticRenderFns } from "./DragCardDeliveries.vue?vue&type=template&id=d0f9bec6&scoped=true"
import script from "./DragCardDeliveries.vue?vue&type=script&lang=js"
export * from "./DragCardDeliveries.vue?vue&type=script&lang=js"
import style0 from "./DragCardDeliveries.vue?vue&type=style&index=0&id=d0f9bec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f9bec6",
  null
  
)

export default component.exports